import { computed, ref, watch } from "vue";
import { useStore } from "vuex";

export default function userRangeSections() {
  const store = useStore();
  const course = ref();
  const openRangeSectionsModal = ref(false);
  const file = ref({ file: "", filename: "" });

  const error = computed(() => store.getters["utilities/getErrors"]);
  const loading = computed(() => store.getters["utilities/isLoading"]);
  const loadingRangeSections = computed(
    () => store.getters["utilities/isLoadingRangeSections"]
  );
  const success = computed(() => store.getters["utilities/getSuccessStatus"]);

  watch(error, (newError) => {
    if (newError) {
      store.dispatch("toastNotification/displayToast", {
        message: newError,
        type: "error",
      });
    }
  });

  watch(success, (newStatus) => {
    if (newStatus) {
      store.dispatch("toastNotification/displayToast", {
        message: "Course configuration updated successfully.",
        type: "success",
      });
    }
  });

  const isFormValid = computed(() => {
    return file.value.file && course.value?.id;
  });

  const uploadRangeSections = () => {
    const payload = new FormData();
    payload.append("file", file.value.file);
    store.dispatch("utilities/uploadRangeSections", {
      payload,
      courseId: course.value?.id,
    });
  };

  const openRangeSectionsTableModal = async () => {
    openRangeSectionsModal.value = true;
    await store.dispatch("utilities/fetchRangeSections", course.value?.id);
  };

  return {
    course,
    file,
    loading,
    loadingRangeSections,
    isFormValid,
    uploadRangeSections,
    openRangeSectionsModal,
    openRangeSectionsTableModal,
  };
}
